export default __webpack_public_path__ + "static/media/facebook.97395030.svg";